import { MyTableComponent, Input } from "components"
import { useState, useEffect } from "react"
import { useTranslation } from "react-i18next"
import { Box } from "theme-ui"
import tittle from "./Tittle.png"
import selectIcon from "./selecticon.png"
import { useDevicesApValuesQuery } from "../../store/Features/devices/devicesApValues-api-slice"

import { IApValues, IApValueElements } from "@types"
export const ApValue = () => {
 const { t } = useTranslation("translation")
 const { data, isLoading } = useDevicesApValuesQuery()
 const [allData, setAllData] = useState<IApValues[]>([])
 const [currentData, setCurrentData] = useState<IApValueElements[]>([])
 const [appValueElements, setAppValueElements] = useState<IApValueElements[]>([])
 const [currentIndex, setCurrentIndex] = useState<number>(0)
 const columns = [
  { Header: "Name", accessor: "name" },
  { Header: t("dataType"), accessor: "datatype" },
  { Header: t("replacement"), accessor: "replacement" },
 ]

 useEffect(() => {
  if (data && currentIndex !== null) {
   setAllData(data)
   const newAppValueElements: any[] = []
   const _currentObject = data?.find((item: IApValues, index: any) => index === currentIndex)
   newAppValueElements.push(_currentObject?.ap_value_elements)
   setAppValueElements(newAppValueElements[0])
   setCurrentData(newAppValueElements[0])
  }
  // eslint-disable-next-line
 }, [data, currentIndex])

 const searchHandler = (keyword: any) => {
  if (keyword !== "") {
   const filterData: any = currentData?.filter(
    (item) => item?.name?.toLowerCase()?.indexOf(keyword.toLowerCase()) !== -1,
   )
   setAppValueElements([...filterData])
  } else {
   setAppValueElements(currentData)
  }
 }
 return (
  <div className="w-[96%] mx-auto relative h-screen  md:h-screen lg:h-full">
   <div className="flex justify-between mx-2 py-4 ">
    <h1 className="font-semibold text-2xl Jakarta-font">{t("apValues")}</h1>
    <div className="flex lg:w-[6%] justify-between">
     <button className="bg-white h-6 w-6 rounded-lg flex items-center justify-center ">
      <img className="rotate-[-90deg]" src={selectIcon} alt="prev" />
     </button>
     <button className="bg-white h-6 w-6 rounded-lg flex items-center justify-center ">
      <img className="rotate-90" src={selectIcon} alt="next" />
     </button>
    </div>
   </div>
   <Box bg="highlight">
    <ul className="flex rounded w-[100%] Jakarta-font overflow-x-scroll hide-scroll-icon">
     {allData &&
      allData?.map((single, index) => (
       <li
        key={index}
        className={`text-xs opacity-70 text-black cursor-pointer rounded px-2 py-3 min-w-[35%] lg:min-w-[0%] ${
         currentIndex === index ? "bg-white rounded font-bold" : "bg-light-gray2"
        }`}
        onClick={() => {
         setCurrentIndex(index)
        }}
       >
        {single?.common_information?.server_name} : {single?.common_information?.device_name}{" "}
       </li>
      ))}
    </ul>
    <div className="py-3 px-3 flex justify-between items-center">
     <h1 className="Jakarta-font font-semibold">Forum Gera: STm.5 Forum Gera</h1>

     <div className="flex items-center justify-end">
      <p className="Jakarta-font">{t("category")}</p>

      <div className="bg-white h-8 w-12 rounded mx-4  border-light-gray border-[1.5px] flex justify-center items-center">
       <img className="w-4" src={tittle} alt="tittlesign" />
      </div>

      {/* ======== SearchHandler  ======== */}
      <div className="w-1/4 hover:w-[45%] transition-all delay-150 duration-700">
       <Input
        onChange={searchHandler}
        className="outline-none text-black border-light-gray border-[1.5px] h-8 rounded  pl-2    "
        placeholder="Search"
        type="search"
       />
      </div>
     </div>
    </div>
   </Box>

   {/* ====== TableComponent ====== */}
   <MyTableComponent
    fullHeight={false}
    columns={columns}
    data={data ? appValueElements : []}
    paginate={true}
    isLoading={isLoading}
   />
  </div>
 )
}
